export default "__VITE_ASSET__BUhguafy__"